import React, { useEffect, useState } from 'react'
import { firestore } from '../../../../firebase'
import ImagePickerReturnUrl from '../../Media/templates/ImagePickerReturnUrl'

function EditPlayer({ player }) {
    const [name, setName] = useState(player?.player_name)
    const [image, setImage] = useState(player?.player_image)
    const [show, setShow] = useState(false)
    const [currentTeamId, setCurrentTeamId] = useState(player?.current_team_id)
    const [playerNumber, setPlayerNumber] = useState(player?.player_number)
    const [playerTeam, setPlayerTeam] = useState(player?.player_team)
    const [playerTotalFixtures, setPlayerTotalFixtures] = useState(
        player?.player_total_fixtures
    )
    const [playerTotalGoals, setPlayerTotalGoals] = useState(
        player?.player_total_goals
    )
    const [playerTotalAssists, setPlayerTotalAssists] = useState(
        player?.player_total_assists
    )

    const [message, setMessage] = useState('')
    const [error, setError] = useState('')

    async function editPlayerHandler(e) {
        e.preventDefault()
        if (!player?.id) {
            setError('Ugyldig spiller id')
            return
        }
        const data = {
            player_name: name,
            player_image: image,
            current_team_id: currentTeamId || '',
            player_number: playerNumber,
            player_team: playerTeam,
            player_total_fixtures: playerTotalFixtures,
            player_total_goals: playerTotalGoals,
            player_total_assists: playerTotalAssists,
        }
        console.log(data)
        try {
            const playerRef = firestore.collection('players-fb').doc(player.id)

            playerRef.update(data)
            setMessage('Oppdatert')
            setError('')
        } catch (error) {
            setMessage('')
            setError('Kunne ikke oppdatere')
        }
    }

    return (
        <div className="my-3">
            <form onSubmit={editPlayerHandler}>
                <label>Navn</label>
                <input
                    className="form-control mb-2"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Spiller navn"
                />

                <p>
                    <label>Velg nytt bilde</label>
                </p>
                <div>
                    <div
                        onClick={() => setShow(true)}
                        className="btn btn-success"
                    >
                        Velg fra galleri
                    </div>
                </div>

                {image && <img src={image} alt="" className="img-fluid" />}

                <p>
                    <label>Spiller nummer</label>
                </p>
                <input
                    className="form-control mb-2"
                    type="number"
                    value={playerNumber}
                    onChange={(e) => setPlayerNumber(e.target.value)}
                />

                <label>Totalt antall kamper i karriere</label>
                <input
                    className="form-control mb-2"
                    type="number"
                    value={playerTotalFixtures}
                    onChange={(e) => setPlayerTotalFixtures(e.target.value)}
                />

                <label>Totalt antall mål i karriere</label>
                <input
                    className="form-control mb-2"
                    type="number"
                    value={playerTotalGoals}
                    onChange={(e) => setPlayerTotalGoals(e.target.value)}
                />

                <label>Totalt antall assist i karriere</label>
                <input
                    className="form-control mb-2"
                    type="number"
                    value={playerTotalAssists}
                    onChange={(e) => setPlayerTotalAssists(e.target.value)}
                />
                {error && (
                    <div
                        className="alert alert-danger"
                        onClick={() => setError('')}
                    >
                        {error}
                    </div>
                )}
                {message && (
                    <div
                        className="alert alert-success"
                        onClick={() => setMessage('')}
                    >
                        {message}
                    </div>
                )}
                <button className="btn btn-primary btn-block">
                    Lagre endringer
                </button>
            </form>
            <ImagePickerReturnUrl
                show={show}
                setShow={setShow}
                imageUrl={image}
                setImageUrl={setImage}
            />
        </div>
    )
}
export default EditPlayer
